import React from 'react';
import { Link } from 'react-router-dom';
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import FacebookButtonComponent from "./FacebookButtonComponent";

function FooterComponent() {
    return (
        <footer className="section-footer">

            <Container maxWidth="md">
                <Grid container spacing={2}>
                    <Grid item xs={9}>
                        <ul>
                            <li><Link to={'/privacy-policy'} className="nav-link">Mentions légales</Link></li>
                        </ul>
                    </Grid>
                    <Grid item xs={3}>
                        <FacebookButtonComponent />
                    </Grid>
                </Grid>
            </Container>


        </footer>
    );
}

export default FooterComponent;
